import { useEffect, useRef } from "react";
import styles from "./PowerMaskView.module.scss";
import { PowerMaskSmall } from "./PowerMaskSmall";
import { PowerMaskBig } from "./PowerMaskBig";
import useObserverNodeSize from "@custom-hooks/useObserverNodeSize";
import { PowerMaskProps, PowerMaskViewBloc } from "./PowerMaskViewBloc";
import useFeatureTags from "@custom-hooks/useFeatureTags";
import { useLocation, useNavigate } from "react-router-dom";
import { useCreation } from "ahooks";

export function PowerMaskView(props: PowerMaskProps) {
  const maskBodyRef = useRef<HTMLDivElement>(null);

  const { size } = useObserverNodeSize(maskBodyRef, false);

  const feature_tag = useFeatureTags();

  const location = useLocation();
  const navigate = useNavigate();

  const bloc = useCreation(() => new PowerMaskViewBloc(props), []);

  useEffect(() => {
    bloc.loadData();
  }, []);
  return (
    <div className={styles.mask_content} ref={maskBodyRef}>
      {props.children}
      {feature_tag.enableStudiosPaywall &&
        bloc.state.showMask.value &&
        (size.width > 300 ? (
          <PowerMaskBig
            featureDescription={bloc.state.featureDescription}
            minimumPlanObj={bloc.state.minimumPlanObj}
            defaultWallName={props.defaultWallName}
            onClick={() => navigate(bloc.getPlanPath(location.pathname))}
          />
        ) : (
          <PowerMaskSmall
            featureDescription={bloc.state.featureDescription}
            minimumPlanObj={bloc.state.minimumPlanObj}
            defaultWallName={props.defaultWallName}
            onClick={() => navigate(bloc.getPlanPath(location.pathname))}
          />
        ))}
    </div>
  );
}
